import { t } from '@lingui/core/macro';

import OverflowTextModal from '@rover/components/src/OverflowTextModal/OverflowTextModal';
import { Box, Heading } from '@rover/kibble/core';

type Props = {
  environment: string;
  onReadMore: () => void;
};

const RevampSafetyTrustEnvironment = ({ environment, onReadMore }: Props): JSX.Element | null => {
  if (!environment) return null;

  return (
    <Box width="100%" pt="6x">
      <OverflowTextModal
        text={environment}
        fixedSizedContent={
          <Heading size="200" mb="4x" webProps={{ as: 'h3' }}>
            {t`Safety, trust & environment`}
          </Heading>
        }
        onReadMore={onReadMore}
      />
    </Box>
  );
};

export default RevampSafetyTrustEnvironment;
